import { Base } from 'components/Containers/BaseContainer';
import { ToolbarContainer } from 'components/Containers/ToolbarContainer';
import SWTab from 'components/Layout/Tabs/SWTab';
import { TabList, TabPanel, Tabs } from 'react-tabs';
import { MaintenanceComparisonView } from './MaintenanceComparison/MaintenanceComparisonView';
import { PartsViewV2 } from './Parts/PartsViewV2';
import { ThemePalette, theme } from 'mui.theme';
import { SVG } from 'components/Asset/SVG';
import { AssetsViewV2 } from './Assets/AssetsViewV2';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';

const { svgIcons } = theme.palette;
/**
 * Renders a tabbed view for managing entities.
 *
 * Current tabs:
 * - Users
 * - Assets
 * - Operator
 */
export const CostAnalysisView = () => {
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  return (
    <Base enableDarkTheme={enableDarkTheme}>
      <Tabs>
        <TabList>
          <ToolbarContainer
            style={{
              paddingBottom: 0,
            }}
            enableDarkTheme={enableDarkTheme}
          >
            {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}
            <SWTab enableDarkTheme={enableDarkTheme}>Assets </SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>Components </SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>
              Maintenance Comparison
            </SWTab>
            {/* Email Icon */}
            <a href="mailto:sample@test.com" style={{ marginLeft: 'auto' }}>
              <SVG
                name="envelopeIcon"
                style={{
                  ...svgIcons?.primary,
                }}
              />
            </a>
          </ToolbarContainer>
        </TabList>

        {/* USER LIST VIEW CONTENT */}
        {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}

        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <AssetsViewV2 enableDarkTheme={enableDarkTheme} />
        </TabPanel>

        {/* ASSET LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <PartsViewV2 enableDarkTheme={enableDarkTheme} />
        </TabPanel>

        {/* Operator LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <MaintenanceComparisonView enableDarkTheme={enableDarkTheme} />
        </TabPanel>
      </Tabs>
    </Base>
  );
};
